import { render, staticRenderFns } from "./TypeOfParkingSpace.vue?vue&type=template&id=72d1d032"
import script from "./TypeOfParkingSpace.vue?vue&type=script&lang=js"
export * from "./TypeOfParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports